export const getPagesQuantity = (lastPage) =>
  lastPage?.meta ? Math.ceil(lastPage.meta.total / lastPage.meta.per_page) : 0;
